import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseCompetingAdsComponent } from '~app/app/competing-ads/abstract-components/base-competing-ads.component';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { CompetingAdsCreationDialogComponent } from '../../modals/competing-ads-creation-dialog/competing-ads-creation-dialog.component';

@Component({
  selector: 'competing-ads-datatable',
  standalone: false,
  templateUrl: './competing-ads-datatable.component.html',
  styleUrl: './competing-ads-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingAdsDatatableComponent extends BaseCompetingAdsComponent {
  private _dialogService = inject(DialogService);
  displayedColumns: string[] = [
    'competitors',
    'sector',
    'media',
    'support',
    'timeSlot',
    'numberOfAds'
  ];

  dataSource = [
    {
      competitors: 'Canal+',
      sector: 'Télévision',
      media: 'Affiche',
      support: '18:00 - 19:00',
      timeSlot: '12/02/2024',
      numberOfAds: 5
    },
    {
      competitors: 'Orange',
      sector: 'Radio',
      media: 'Spot',
      support: '08:00 - 09:00',
      timeSlot: '15/03/2024',
      numberOfAds: 3
    }
  ];

  openAddDialog(): void {
    this._dialogService.open({
      component: CompetingAdsCreationDialogComponent,
      fullscreen: true
    });
  }
}
